module.exports = __webpack_public_path__ + "img/cnn-banner.307a1542.jpg";